import ListView from "./ListView/ListView";

const DimensionalTags = {
  ListView,
};

export default DimensionalTags;
